var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Upload',{attrs:{"id":_vm.id,"src":_vm.src},on:{"success":_vm.onLogoUpload}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }